module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.327362a7.ttf";